import React from 'react';
import {usePromiseTracker} from 'react-promise-tracker';
import Loader from '@ey/canvascoreservices/LoadingIndicator';

const TrackerLoader = (props) => {
	const trackers = [];

	if (props.areas) {
		_.forEach(props.areas, (area) => {
			const {promiseInProgress} = usePromiseTracker({area: area});
			trackers.push(promiseInProgress);
		});
	}

	return trackers.length > 0 && _.some(trackers) ? (
		<Loader show ={true} view={props.view ? props.view : ''} styleName={props.styleName ? props.styleName : ''} fullscreen={props.fullscreen}/>
	) : null;
};

export default TrackerLoader;
